<template>
	<tr @click="redirectToShowPage" class="requirement-record">
		<td
			class="pa-1 normal-wrap text-center sticky-01"
			@click="
				openEditDialog(
					'shipping_date',
					deliveryInfo.shipping_date ? toDateFormat(deliveryInfo.shipping_date) : null,
					null,
					'出荷日'
				)
			"
			v-text="deliveryInfo.shipping_date ? toDateFormat(deliveryInfo.shipping_date) : ''"
		></td>
		<td class="pa-1 normal-wrap text-center sticky-02" v-text="orderedProduct.keyword"></td>
		<td class="pa-1 normal-wrap text-center sticky-03">
			<a @click="orderedProductOpenFlag = true">
				{{ orderedProduct.product_number }}
			</a>
		</td>
		<td class="pa-1 normal-wrap text-center sticky-04">
			<a @click="orderIndividualInfoOpenFlag = true">
				{{ common.zeroPadding(orderIndividualInfo.sub_number, 3) }}
			</a>
		</td>
		<td class="pa-1 normal-wrap text-center sticky-05" v-text="requirement.user.last_name"></td>
		<td
			class="pa-1 normal-wrap text-center sticky-06"
			v-text="requirement.matter.order_number"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				orderIndividualInfo.shipping_permit_date
					? toDateFormat(orderIndividualInfo.shipping_permit_date)
					: ''
			"
		></td>
		<td class="pa-1 normal-wrap text-center">
			{{ orderIndividualInfo.permit_user ? orderIndividualInfo.permit_user.last_name : "" }}
		</td>
		<td class="pa-1 normal-wrap text-center" v-text="orderedProduct.product.name"></td>
		<td class="pa-1 normal-wrap text-center" v-text="orderedProduct.sub_name"></td>
		<td class="pa-1 normal-wrap text-center" v-text="orderIndividualInfo.quantity"></td>
		<td class="pa-1 normal-wrap text-center" v-text="matter.regular_customer.name"></td>
		<td class="pa-1 normal-wrap text-center" v-text="matter.customer_company.name"></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="deliveryInfo.prefecture"
			@click="
				openEditDialog(
					'prefecture',
					deliveryInfo.prefecture ? deliveryInfo.prefecture : null,
					null,
					'都道府県'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="deliveryInfo.city"
			@click="
				openEditDialog('city', deliveryInfo.city ? deliveryInfo.city : null, null, '市郡町村')
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			@click="
				openEditDialog(
					'deadline',
					deliveryInfo.deadline ? toDateFormat(deliveryInfo.deadline) : null,
					null,
					'納期'
				)
			"
			v-text="toDateFormat(deliveryInfo.deadline)"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			@click="
				openEditDialog(
					'remarks',
					selectValueFromValues('特記事項'),
					selectValueIdFromValues('特記事項'),
					'特記事項'
				)
			"
			v-text="selectValueFromValues('特記事項')"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			@click="
				openEditDialog(
					't_method',
					selectValueFromValues('運送方法'),
					selectValueIdFromValues('運送方法'),
					'運送方法'
				)
			"
			v-text="selectValueFromValues('運送方法')"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('車種')"
			@click="
				openEditDialog(
					'car_model',
					selectValueFromValues('車種'),
					selectValueIdFromValues('車種'),
					'車種'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('台数')"
			@click="
				openEditDialog(
					'number_of_vehicles',
					selectValueFromValues('台数'),
					selectValueIdFromValues('台数'),
					'台数'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('荷姿')"
			@click="
				openEditDialog(
					'packing_style',
					selectValueFromValues('荷姿'),
					selectValueIdFromValues('荷姿'),
					'荷姿'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('個数')"
			@click="
				openEditDialog(
					'number_of_paking',
					selectValueFromValues('個数'),
					selectValueIdFromValues('個数'),
					'個数'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				selectValueFromValues('重量(kg)') ? selectValueFromValues('重量(kg)').toLocaleString() : ''
			"
			@click="
				openEditDialog(
					'kg',
					selectValueFromValues('重量(kg)'),
					selectValueIdFromValues('重量(kg)'),
					'重量(kg)'
				)
			"
		></td>
		<td
			class="pa-1 pre-wrap text-center"
			v-text="selectValueFromValues('備考')"
			@click="
				openEditDialog(
					'biko',
					selectValueFromValues('備考'),
					selectValueIdFromValues('備考'),
					'備考'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('梱包指定')"
			@click="
				openEditDialog(
					'packing_spec',
					selectValueFromValues('梱包指定'),
					selectValueIdFromValues('梱包指定'),
					'梱包指定'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('送品案内')"
			@click="
				openEditDialog(
					'shipping_guide',
					selectValueFromValues('送品案内'),
					selectValueIdFromValues('送品案内'),
					'送品案内'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('指定伝票')"
			@click="
				openEditDialog(
					'designated_form',
					selectValueFromValues('指定伝票'),
					selectValueIdFromValues('指定伝票'),
					'指定伝票'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('成績書')"
			@click="
				openEditDialog(
					'report_of_results',
					selectValueFromValues('成績書'),
					selectValueIdFromValues('成績書'),
					'成績書'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('現品表')"
			@click="
				openEditDialog(
					'specimen_list',
					selectValueFromValues('現品表'),
					selectValueIdFromValues('現品表'),
					'現品表'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('返信封筒')"
			@click="
				openEditDialog(
					'return_envelope',
					selectValueFromValues('返信封筒'),
					selectValueIdFromValues('返信封筒'),
					'返信封筒'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('図面')"
			@click="
				openEditDialog(
					'drawing',
					selectValueFromValues('図面'),
					selectValueIdFromValues('図面'),
					'図面'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('地図')"
			@click="
				openEditDialog('map', selectValueFromValues('地図'), selectValueIdFromValues('地図')),
					'地図'
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('出荷許可')"
			@click="
				openEditDialog(
					'shipping_permittion',
					selectValueFromValues('出荷許可'),
					selectValueIdFromValues('出荷許可'),
					'出荷許可'
				)
			"
		></td>

		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				selectValueFromValues('運送費') ? selectValueFromValues('運送費').toLocaleString() : ''
			"
			@click="
				openEditDialog(
					'freight_costs',
					selectValueFromValues('運送費'),
					selectValueIdFromValues('運送費'),
					'運送費'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('運賃') ? selectValueFromValues('運賃').toLocaleString() : ''"
			@click="
				openEditDialog(
					'fare',
					selectValueFromValues('運賃'),
					selectValueIdFromValues('運賃'),
					'運賃'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				selectValueFromValues('中継料') ? selectValueFromValues('中継料').toLocaleString() : ''
			"
			@click="
				openEditDialog(
					'relay_fee',
					selectValueFromValues('中継料'),
					selectValueIdFromValues('中継料'),
					'中継料'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				selectValueFromValues('冬季割増料')
					? selectValueFromValues('冬季割増料').toLocaleString()
					: ''
			"
			@click="
				openEditDialog(
					'winter_surcharge',
					selectValueFromValues('冬季割増料'),
					selectValueIdFromValues('冬季割増料'),
					'冬季割増料'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				selectValueFromValues('保険料') ? selectValueFromValues('保険料').toLocaleString() : ''
			"
			@click="
				openEditDialog(
					'insurance_premium',
					selectValueFromValues('保険料'),
					selectValueIdFromValues('保険料'),
					'保険料'
				)
			"
		></td>

		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				selectValueFromValues('チャーター料')
					? selectValueFromValues('チャーター料').toLocaleString()
					: ''
			"
			@click="
				openEditDialog(
					'charter_fee',
					selectValueFromValues('チャーター料'),
					selectValueIdFromValues('チャーター料'),
					'チャーター料'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('受領書')"
			@click="
				openEditDialog(
					'receipt',
					selectValueFromValues('受領書'),
					selectValueIdFromValues('受領書'),
					'受領書'
				)
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectValueFromValues('発注＆受入したか')"
			@click="
				openEditDialog(
					'ordered_accepted',
					selectValueFromValues('発注＆受入したか'),
					selectValueIdFromValues('発注＆受入したか'),
					'発注＆受入したか'
				)
			"
		></td>
		<td class="pa-1 normal-wrap text-center" v-text="getQuoteRequestNumber()"></td>
		<td class="pa-1 normal-wrap text-center" v-text="getQuoteRequestAnswerDate()"></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectQuotePrice('オーナミ') ? selectQuotePrice('オーナミ').toLocaleString() : ''"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="
				selectQuotePrice('日本ロジコム') ? selectQuotePrice('日本ロジコム').toLocaleString() : ''
			"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="selectQuotePrice('城南運輸') ? selectQuotePrice('城南運輸').toLocaleString() : ''"
		></td>
		<LogisticsEditDialog ref="edit" @reloadIndex="reloadIndex" />
		<OrderedProductSingleDialog
			v-if="orderedProductOpenFlag"
			:ordered_product="orderedProduct"
			@close="orderedProductOpenFlag = false"
		/>
		<OrderIndividualInfoSingleDialog
			v-if="orderIndividualInfoOpenFlag"
			:ordered_product="orderedProduct"
			:order_individual_info="orderIndividualInfo"
			@close="orderIndividualInfoOpenFlag = false"
		/>
	</tr>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import moment from "moment/min/moment.min.js"
import common from "../../../helper/common.js"
import LogisticsEditDialog from "./LogisticsEditDialog.vue"
import OrderedProductSingleDialog from "../../shared/OrderedProductSingleDialog.vue"
import OrderIndividualInfoSingleDialog from "../../shared/OrderIndividualInfoSingleDialog.vue"
export default {
	components: {
		LogisticsEditDialog,
		OrderedProductSingleDialog,
		OrderIndividualInfoSingleDialog,
	},
	props: {
		openMatterFlag: false,
		requirement: {},
		answer: { answer_values: [] },
		matter: { matter_product: { sub_name: "" } },
		orderedProduct: {},
		orderIndividualInfo: {},
		deliveryInfo: {},
		recordIndex: "",
	},
	data() {
		return {
			orderedProductOpenFlag: false,
			orderIndividualInfoOpenFlag: false,

			common: common,
			flags: {
				shipping_date: false,
				remarks: false,
			},
			newAnswerValue: {
				remarks: "",
			},
		}
	},
	filters: {
		dateForRequirement: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
		timeForRequirement: function (time) {
			if (!time) return ""
			return moment(time).format("HH:mm")
		},
		filterYear: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY")
		},
		filterMonth: function (date) {
			if (!date) return ""
			return moment(date).format("MM")
		},
		filterDay: function (date) {
			if (!date) return ""
			return moment(date).format("DD")
		},
	},
	watch: {},

	methods: {
		reloadIndex() {
			this.$emit("reloadIndex")
		},
		openEditDialog(target, nowData, valueId = "", jap) {
			this.$refs.edit.openDialog(this.requirement, target, nowData, valueId, jap)
		},
		selectQuotePrice(word) {
			let returnPrice = null
			this.matter.quote_requests.forEach((qr) => {
				if (qr.logi_quote) {
					if (qr.supplier.name == word) {
						returnPrice = qr.logi_quote.price
					}
				}
			})
			return returnPrice
		},
		getQuoteRequestNumber() {
			if (this.matter.quote_requests.length > 0) {
				let numbers = this.matter.quote_requests.map((obj) => obj.quote_number).join(", ")
				return numbers
			}
		},
		getQuoteRequestAnswerDate() {
			if (this.matter.quote_requests.length > 0) {
				let dates = []
				dates = this.matter.quote_requests.map((obj) => {
					if (obj.answer_date) {
						return obj.answer_date
					}
				})
				let datesString = dates
					.map((date) => {
						if (date) {
							return moment(date).format("YYYY/MM/DD")
						}
					})
					.join(", ")
				return datesString
			}
		},
		redirectToShowPage() {},
		toDateFormat(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD")
			} else {
				return null
			}
		},
		selectValueDataFromValues(name) {
			let returnValue = null
			if (this.answer) {
				this.answer.answer_values.forEach((value) => {
					if (value.answer_column.name == name) {
						returnValue = value
					}
				})
			}
			return returnValue
		},
		selectValueIdFromValues(name) {
			let returnId = null
			if (this.answer) {
				this.answer.answer_values.forEach((value) => {
					if (value.answer_column.name == name) {
						returnId = value.id
					}
				})
			}
			return returnId
		},
		selectValueFromValues(name) {
			let returnValue = null
			if (this.answer) {
				this.answer.answer_values.forEach((value) => {
					if (value.answer_column.name == name) {
						returnValue = value
					}
				})
				if (returnValue != null) {
					return common.returnValueValue(returnValue)
				} else {
					return null
				}
			} else {
				return null
			}
		},
		latestDeliveryInfo(infos) {
			let sorted = this.common.sortCreatedAtDESC(infos)
			return sorted[0]
		},
	},
	computed: {},
}
</script>

<style scoped lang="scss">
th,
td {
	border-left: solid gray 1px;
}
td {
	white-space: pre-wrap;
}

.requirement-record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.requirement-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
</style>
